import { connect } from 'react-redux';

import { CancelEventModalContent } from './CancelEventModalContent';
import { cancelEvent } from 'api/events/events.actions';

const mapDispatchToProps = (dispatch: Function) => ({
  cancelEvent: (eventId: string) => dispatch(cancelEvent({ id: eventId, state: 'Cancelled' })),
});

export const CancelEventModalContentContainer = connect(null, mapDispatchToProps)(CancelEventModalContent);
